<template>
  <div>
    <article class="con1">
      <div class="con-wrapper">
        <div class="con1-text">
          <p>최고의 만족도를 자랑하는 이유</p>
          <div class="text-slide">
            <VueSlickCarousel ref="c1" v-bind="settings1">
              <div>
                <p>중국 현지<br />원어민 강사님과 수업</p>
              </div>
              <div>
                <p>나만의<br />1:1 학습코칭 매니저</p>
              </div>
              <div>
                <p>체계적인 교재와<br />학습프로세스</p>
              </div>
              <div>
                <p>학습효과 100%,<br />출석율 100%</p>
              </div>
            </VueSlickCarousel>
          </div>
        </div>
        <div class="content-slide">
          <VueSlickCarousel ref="c2" v-bind="settings2">
            <div class="item">
              <img
                src="@/assets/img/chinese/index/con1/item1-m.png"
                alt="icon"
                class="item-m"
              />
              <img
                src="@/assets/img/chinese/index/con1/item1-pc.png"
                alt="icon"
                class="item-pc"
              />
            </div>
            <div class="item">
              <img
                src="@/assets/img/chinese/index/con1/item2-m.png"
                alt="icon"
                class="item-m"
              />
              <img
                src="@/assets/img/chinese/index/con1/item2-pc.png"
                alt="icon"
                class="item-pc"
              />
            </div>
            <div class="item">
              <img
                src="@/assets/img/chinese/index/con1/item3-m.png"
                alt="icon"
                class="item-m"
              />
              <img
                src="@/assets/img/chinese/index/con1/item3-pc.png"
                alt="icon"
                class="item-pc"
              />
            </div>
            <div class="item">
              <img
                src="@/assets/img/chinese/index/con1/item4-m.png"
                alt="icon"
                class="item-m"
              />
              <img
                src="@/assets/img/chinese/index/con1/item4-pc.png"
                alt="icon"
                class="item-pc"
              />
            </div>
          </VueSlickCarousel>
        </div>
      </div>
    </article>
  </div>
</template>
<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
export default {
  components: { VueSlickCarousel },
  data() {
    return {
      settings1: {
        arrows: false,
        dots: false,
        fade: true,
        infinite: true,
        swipeToSlide: false,
        initialSlide: 0,
        slidesToShow: 1,
        slidesToScroll: 1,
        asNavFor: null,
        swipe: false,
      },
      settings2: {
        dots: true,
        infinite: true,
        arrows: false,
        autoplay: true,
        speed: 1000,
        autoplaySpeed: 4000,
        cssEase: "ease-out",
        centerMode: false,
        pauseOnHover: false,
        swipeToSlide: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        focusOnSelect: false,
        initialSlide: 0,
        variableWidth: true,
        asNavFor: null,
        responsive: [
          {
            breakpoint: 1049,
            settings: {
              centerMode: true,
              centerPadding: "70px",
              variableWidth: false,
            },
          },
        ],
      },
    };
  },
  mounted() {
    this.settings1.asNavFor = this.$refs.c2;
    this.settings2.asNavFor = this.$refs.c1;
  },
};
</script>
<style lang="scss" scoped>
img {
  display: block;
  width: 100%;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
}

.con1 {
  padding: 85px 0;
  overflow: hidden;

  @media screen and (min-width: 1050px) {
    padding: 160px 0;
  }

  .con-wrapper {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 35px;

    @media screen and (min-width: 1050px) {
      flex-direction: row;
      gap: 108px;
      max-width: 1000px;
      margin: 0 auto;
    }

    .con1-text {
      flex: none;

      > p {
        font-size: 16px;
        font-weight: 700;
        color: #7b53eb;
        text-align: center;
        margin-bottom: 16px;

        @media screen and (min-width: 1050px) {
          font-size: 28px;
          text-align: left;
          margin-bottom: 44px;
        }
      }

      :deep(.text-slide) {
        width: 450px;
        overflow: hidden;

        p {
          font-size: 30px;
          font-weight: 700;
          color: #09090b;
          text-align: center;

          @media screen and (min-width: 1050px) {
            font-size: 50px;
            text-align: left;
          }
        }
      }
    }

    :deep(.content-slide) {
      width: 100%;

      @media screen and (min-width: 1050px) {
        flex: none;
      }

      .slick-slider {
        position: relative;

        @media screen and (min-width: 1050px) {
          position: static;
        }

        .slick-list {
          padding-left: 20px;
          @media screen and (min-width: 1050px) {
            padding-left: 0;
          }

          .slick-track {
            display: flex !important;
            align-items: center;
            margin-bottom: 36px;

            @media screen and (min-width: 1050px) {
              margin-bottom: 0;
            }

            &::before,
            &::after {
              display: none;
            }

            .slick-slide {
              transform: scale(0.8);
              height: 100%;
              border-radius: 42px;
              overflow: hidden;
              margin: 0 8px;

              @media screen and (min-width: 768px) {
                border-radius: 72px;
                margin: 0 20px;
              }

              @media screen and (min-width: 1050px) {
                border-radius: 42px;
              }

              > div {
                width: 100%;
                height: 100%;

                .item {
                  display: block !important;

                  .item-m {
                    @media screen and (min-width: 1050px) {
                      display: none;
                    }
                  }

                  .item-pc {
                    display: none;

                    @media screen and (min-width: 1050px) {
                      display: block;
                      width: min-content;
                    }
                  }
                }
              }

              &.slick-current {
                transform: scale(0.9);
                box-shadow: 6px 6px 15px rgba($color: #000000, $alpha: 0.16);
              }
            }
          }
        }

        .slick-dots {
          display: flex !important;
          justify-content: center;
          gap: 20px;
          position: relative !important;
          bottom: 0 !important;

          @media screen and (min-width: 1050px) {
            position: absolute !important;
            left: 0;
            bottom: 50px !important;
            justify-content: flex-start;
            gap: 10px;
          }

          li {
            width: 10px;
            height: 10px;
            margin: 0;

            button {
              position: relative;
              font-size: unset;
              padding: 0;
              width: 10px;
              height: 10px;
              display: flex;
              align-items: center;
              justify-content: center;

              &::before {
                content: "";
                font-size: 0;
                width: 10px;
                height: 10px;
                line-height: 0;
                background-color: #e5e7eb;
                border-radius: 100%;
                opacity: 1;
              }
            }

            &.slick-active {
              button {
                position: relative;
                font-size: unset;
                padding: 0;
                width: 10px;
                height: 10px;
                display: flex;
                align-items: center;
                justify-content: center;

                &::before {
                  content: "";
                  font-size: 0;
                  width: 10px;
                  height: 10px;
                  line-height: 0;
                  background-color: #9ca3af;
                  border-radius: 100%;
                  opacity: 1;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
